import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loading: false,
        isLoading: false,
        licenseplate: '',
        vehicleData: null,
        searching: false,
        match: false,
        loadingWanted: false,
        loadingDmr: false,
        loadingInspection: false,
        loadingRegistry: false,
        loadingLookups: false,
        showingResult: false,
        carData: {
            general: null,
            dmr: null,
            registry: null,
            inspection: null,
            lookups: null,
            wanted: null
        }
    },
    modules: {
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js